import { sv } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { useState } from "react";
import { Button } from "@/shared/components/ui/button";
import { Calendar } from "@/shared/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/components/ui/popover";
import { fromIso, toDayMonth, toIso, toWeekdayName } from "@/shared/utils/date";

const defaultLabel = (iso: string) =>
  `${toWeekdayName(iso)} ${toDayMonth(iso)}`;

export function DatePicker(props: {
  value: string;
  onChange: (iso: string) => void;
  label?: (iso: string) => string;
  disabledBefore?: string;
}) {
  const { value, onChange, label = defaultLabel, disabledBefore } = props;
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className="w-full justify-start font-normal"
        >
          <CalendarIcon className="text-muted-foreground" />
          {label(value)}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={fromIso(value)}
          defaultMonth={fromIso(value)}
          disabled={
            disabledBefore ? { before: fromIso(disabledBefore) } : undefined
          }
          onSelect={(date) => {
            if (!date) return;
            onChange(toIso(date));
            setOpen(false);
          }}
          locale={sv}
          weekStartsOn={1}
        />
      </PopoverContent>
    </Popover>
  );
}
